import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSimpleContenteditableComponent } from './fi-simple-contenteditable.component';
import { FiContenteditableModule } from '../fi-contenteditable/fi-contenteditable.module';
import { FiAppTextSharedModule } from '../app-text';
import { FiTextPanelModule } from '../fi-text-panel/fi-text-panel.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiTextEditorSharedModule } from '../fi-text-editor/fi-text-editor-shared.module';
import { FiTextItemMediaPanelHandlerModule } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-handler.module';

@NgModule({
    imports: [
        CommonModule,
        FiContenteditableModule,
        FiAppTextSharedModule,
        FiTextPanelModule,
        FiAttachmentsModule,
        MatDividerModule,
        MatIconModule,
        MatButtonModule,
        FiTextEditorSharedModule,
        FiTextItemMediaPanelHandlerModule,
    ],
    declarations: [FiSimpleContenteditableComponent],
    exports: [FiSimpleContenteditableComponent],
})
export class FiSimpleContenteditableModule {}
